// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"339":"d735e1c3","628":"5d08d807","767":"e823892d"}[chunkId] + ".chunk.css";
};